<template>
	<div class="case-notification-users">

		<InputGroup
			title="Notification Users"
			desc="Select which users should receive notifications about this case. Deselect those who should not."
			:darkMode="true"
			:oneColumn="true"
			:skipWhiteBox="true"
			>
			<MultiSelect
				:options="customNotifiableUsers"
				v-model="caseForm.notifiedUsers"
				:showAsTags="showAsTags"
				:showSelectedList="false"
				:enableSearch="false"
				/>      
		</InputGroup>

		<InputGroup
			v-if="alwaysNotifiedAdmins.length > 0"
			title="Always notified admins"
			desc="The following admins will always receive notifications about this case, regardless of the above selection."
			:darkMode="true"
			:oneColumn="true"
			:skipWhiteBox="true"
			>

			<ul class="always-notified-admins-list">
				<li 
					v-for="admin in alwaysNotifiedAdmins" 
					:key="admin.id"
					>
					<span>
						{{ admin.name }}
					</span>
				</li>
			</ul>

		</InputGroup>


		<InputGroup
			title=""
			desc=""
			:skipWhiteBox="true"
			:noLine="true"
			:condensed="true"
			:oneColumn="true"
			:fixedToBottom="true"
			>
			<Button
				label="Save"
				color="green"
				size="large"
				icon="save" 
				@click="submitNotifications"
				/>
		</InputGroup>


	</div>
</template>

<script>

import InputGroup from "@/Components/InputGroup"
import Button from "@/Components/Button"
import MultiSelect from "@/Components/MultiSelect"
import OnOffPill from "@/Components/InputOnOffPill"

export default {
	props: [
		'thisCase',
		'notifiableUsers',
		'alwaysNotifiedAdmins'
	],
	components: {
		InputGroup,
		Button,
		MultiSelect,
		OnOffPill
	},
	data: () => {
		return {
			caseForm: {
				notifiedUsers: []
			},
			showAsTags: [
				'case_relation',
				'notifications_enabled',
				// 'user_type'
			],
		}
	},
	mounted(){
		// console.log('notifiableUsers', this.notifiableUsers)
		// console.log('thisCase', this.thisCase)

		this.caseForm.notifiedUsers = this.thisCase.notification_users.map(viewer => viewer.id) // load in existing values

	},
	methods: {
		submitNotifications(){
			this.$inertia.post(`/admin/cases/${this.thisCase.hashid}/notification-users`, this.caseForm)  
		},
		relationToCase(userId){ 
			// check thisCase's arrays for editors and viewers if userId is in any of them, if they are, return which array they were in. Each array has objects, within each object the 'id' key relates to the user ID
			if(this.thisCase.editors.find(editor => editor.id === userId)){
				return 'Supporting Surgeon'
			}
			if(this.thisCase.viewers.find(viewer => viewer.id === userId)){
				return 'Viewer'
			}
			if(this.thisCase.dedicated_admin_user === userId){
				return 'Rep'
			}
			if(this.thisCase.user_id === userId){
				return 'Primary Surgeon'
			}

			return false
		},
		translateUserType(userType){
			switch(userType){
				case 'admin':
					return 'Super Admin'
				case 'user':
					return 'User'
				default:
					return false
			}
		}
	},
	computed: {
		customNotifiableUsers(){
			let customUsers = this.notifiableUsers.map(user => {
				let allow_contact = ['email'].includes(user.contact_pref)
				return {
					id: user.id,
					name: user.name,
					case_relation: this.relationToCase(user.id),
					disabled: !allow_contact,
					notifications_enabled: !allow_contact ? 'Notifications Disabled' : null,
					user_type: this.translateUserType(user.user_type)
				}
			})

			// now reorder the customUsers array so that any with a case_relation are at the top
			customUsers.sort((a, b) => {
				if(a.case_relation && !b.case_relation){
					return -1
				}
				if(!a.case_relation && b.case_relation){
					return 1
				}
				return 0
			})

			return customUsers
		}
	}
}

</script>

<style scoped lang="sass">

.case-notification-users
	select[multiple]
		width: 100%
		min-height: 200px

	.always-notified-admins-list
		list-style: none
		padding: 0
		margin: 0
		display: flex
		flex-direction: column
		gap: 8px

		li
			padding: 0
			margin: 0

			span
				padding: 5px 8px
				color: #f2f2f2
				border-radius: 3px
				background-color: rgba(#fff, 0.1)
				font-size: 14px



</style>